import initAppearAnim from './utils/appear-anim';
import initItemsScrollDown from './blocks/items-scroll-down';
import initNav from './components/navigation';
import initCategoriesNav from './components/categories-nav';
import initQuoteCarousel from './blocks/quote';
import initContact from './blocks/contact';

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Modules
initNav();

// Blocks
initItemsScrollDown();
initQuoteCarousel();
initContact();

//Utils
initAppearAnim();

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initCategoriesNav();


